import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SLIDE_FILTER_VALUES } from '@features/curriculum/types';

// filter — предвыбранный фильтр слайдов: с ним урок открывают счетчики в списке
const querySchema = z.object({
  filter: z.enum(SLIDE_FILTER_VALUES).optional(),
});

export const Route = createFileRoute('/curriculum/lessons_/$courseId/$lessonId')({
  validateSearch: querySchema,
});
